"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SensorPlacement = _interopRequireDefault(require("../components/AddSensor/SensorPlacement"));
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _Services = require("../common_features/utility/Services");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const EditSensorPlacement = () => {
  const navigate = (0, _reactRouterDom.useNavigate)();
  const {
    selectedAccessory
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const [selectedOption, setSelectedOption] = (0, _react.useState)(selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppPlacement);
  const [isUpdating, setIsUpdating] = (0, _react.useState)(false);
  const [openErrorModal, setOpenErrorModal] = (0, _react.useState)(false);
  const options = ["8:Inlet", "6:Outlet"];
  const deleteErrorModalData = {
    variant: "error-modal",
    displayModal: openErrorModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalHeaderText: "Error",
    modalHeaderTextStyle: {
      color: "#E00932"
    },
    modalDetailText: "The requested action did not complete successfully, please try again.",
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Retry",
    negativeButtonActionTitle: "Cancel",
    positiveAction: () => handleDeleteErrorRetry(),
    negativeAvtion: () => handleDeleteErrorCancel()
  };
  const handleDeleteErrorRetry = () => {
    setOpenErrorModal(false);
    handleClick();
  };
  const handleDeleteErrorCancel = () => {
    setOpenErrorModal(false);
  };
  const handleClick = async () => {
    setIsUpdating(true);
    setOpenErrorModal(false);
    const data = {
      "systemId": selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.systemId,
      "systemReferences": [{
        "refAppId": selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppId,
        "refAppPlacement": selectedOption,
        "refAppName": selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppName,
        "refAppType": selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppType
      }]
    };
    try {
      await (0, _Services.updateSystem)(data);
      setIsUpdating(false);
      navigate(-2);
    } catch (error) {
      setOpenErrorModal(true);
      setIsUpdating(false);
    }
  };
  const handleBackBtn = () => {
    navigate(-2);
  };
  const handleOptionData = (e, value) => {
    e.preventDefault();
    setSelectedOption(value);
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_SensorPlacement.default, {
    handleClick: handleClick,
    navHeading: "System Dashboard",
    handleBack: handleBackBtn,
    headerText: "".concat(selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppModelNumber, " ", " Placement"),
    subContent: "Select your sensor placement",
    bottomBtnTitle: "Continue",
    sensorBtnDisable: selectedOption ? false : true,
    sensorImage: _index.default.mrsDevice.default,
    handleOptionData: handleOptionData,
    options: options,
    selectedOption: selectedOption,
    isUpdating: isUpdating,
    modalData: deleteErrorModalData
  }));
};
var _default = exports.default = EditSensorPlacement;